// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * Merge one Stargate's /proxy/network/batch-clients result into clientData.
 *
 * A later timeout or per-device error must not overwrite a prior good list.
 * An empty `clients: []` is success (zero downstream clients), not "unreachable".
 * `fetchError` is write-only bookkeeping — ClientBadge keys off `error` only.
 */
export function mergeBatchClientEntry(prevEntry, nextSuccess, errorMessage) {
  if (nextSuccess) {
    return nextSuccess;
  }
  const keepLastGood =
    prevEntry && prevEntry.error !== true && Array.isArray(prevEntry.clients);
  if (keepLastGood) {
    return {
      ...prevEntry,
      fetchError: true,
      fetchErrorMessage: errorMessage,
    };
  }
  return {
    online: 0,
    clients: [],
    error: true,
    errorMessage,
    lastUpdated: new Date().toISOString(),
  };
}
